__turbopack_context__.v({
  "chip": "Chip-module-scss-module__Npp-uW__chip",
  "clickable": "Chip-module-scss-module__Npp-uW__clickable",
  "disabled": "Chip-module-scss-module__Npp-uW__disabled",
  "label": "Chip-module-scss-module__Npp-uW__label",
  "remove-button": "Chip-module-scss-module__Npp-uW__remove-button",
});
